defer(function() {
    window.jQuery(document).ready(function() {
        //JQuery for site-wide use
        //console.log('Celebration script loaded');


        //crewards and groups pages smooth scrolling
        $(document).on('click', '.tab-styled-navigation-account.smooth-scroll a[href^="#"]', function (event) {
            event.preventDefault();

            $('html, body').animate({
                scrollTop: $($.attr(this, 'href')).offset().top
            }, 500);
        });

        //groups pages nav: switch to the button grid once the tab row wraps to a second line
        $('.tab-styled-navigation-account.groups-pages').each(function () {
            var nav = this;
            var items = nav.querySelectorAll('ul.sfs-tabstrip-configurator > li');
            if (!items.length) return;

            function fit() {
                nav.classList.remove('is-stacked');
                if (items[items.length - 1].offsetTop > items[0].offsetTop) {
                    nav.classList.add('is-stacked');
                }
            }

            fit();
            $(window).on('resize', fit);
            if (document.fonts && document.fonts.ready) {
                document.fonts.ready.then(fit);
            }
        });

        //function shareThisCinemasShowtimes(this) {
        //$('.cinema-location-share-icon').on('click', function() {
        $(document).on('click', '.cinema-location-share-icon', function() {
                console.log('cinema box click');
                var s_cinema = $(this).data('cinemaValue');
                var s_url = $("#share-film-url").val();
                var s_title = $("#share-film-title").val();
                var s_hocode = $("#share-film-hocode").val();
                var s_date = $("#share-film-date").val();
                var s_format = $("#share-film-format").val();

                //console.log('sharing cinema share', s_url, s_title, s_hocode, s_cinema, s_date, s_format);
                
                //showtime string builder
                var showtimelist = "";
                var showtimeboxcontainer = $(this).parent('.card.movie-card').find('.show-time-box-container');
                var formats = $(showtimeboxcontainer).find('.format-container');
                var flength = formats.length;
                //console.log('formats', flength);
                $(formats).each(function() {
                    var formatTitle = $(this).find('h3').text().trim();
                    var times = $(this).find('.show-time-col');
                    showtimelist += " \n\n"+formatTitle +": ";
                    var slength = times.length;
                    //console.log('shows', slength);
                    $(times).each(function(index, elm) {
                        var a_showing = $(this).find('.show-time-box').data('showtimeValue').toString();
                        //console.log(index, (slength - 1));
                        if (index === (slength - 1)) {
                            showtimelist += a_showing;
                        } else {
                            showtimelist += a_showing + ", ";
                        }
                    });
                });

                shareShowtimeLink(s_url, s_title, s_hocode, s_cinema, s_date, s_format, 'cinema', $(this), showtimelist);
        });
        //}

        $('#share-film-button-mobile, #share-film-button-desktop').on('click', function() {
                //console.log('film click');
                var s_url = $("#share-film-url").val();
                var s_title = $("#share-film-title").val();
                var s_hocode = $("#share-film-hocode").val();
                var s_cinema = $("#share-film-cinema").val();
                var s_date = $("#share-film-date").val();
                var s_format = $("#share-film-format").val();

                //console.log('sharing film share', s_url, s_title, s_hocode, s_cinema, s_date, s_format);
                shareShowtimeLink(s_url, s_title, s_hocode, s_cinema, s_date, s_format, 'film', $(this), "");
        });

        function shareShowtimeLink(s_url, s_title, s_hocode, s_cinema, s_date, s_format, share_button, self, showtimelist) {
                //var s_url = $("#share-film-url").val();
                //var s_title = $("#share-film-title").val();
                //var s_hocode = $("#share-film-hocode").val();
                //var s_cinema = $("#share-film-cinema").val();
                //var s_date = $("#share-film-date").val();
                //var s_format = $("#share-film-format").val();
                
                console.log('film share values', s_url, s_title, s_hocode, s_cinema, s_date, s_format, share_button, showtimelist);

                var mTime = new Date()
                var dayOfWeekAndMonth = new Date();
                var nowDate =  moment().tz('America/New_York');
				var iscurrentDate = null;
                
                //console.log('1');
                if (s_date) {
                    //let fDate = new Date(s_date);
				    let mDate = moment(s_date, "YYYY-MM-DD", 'America/New_York');
                    var iscurrentDate = mDate.isSame(nowDate, "day");
                    dayOfWeekAndMonth  = moment(mDate).format('dddd, MMM. Do');
                } else {
                    //no date, just assume it is today/no filter
                    iscurrentDate = true;
                }
                //console.log('2');
                //url builder
                var filterAdded = false;

                if (s_date) {
                    var formattedDate = moment(s_date, "YYYY-MM-DD").format("YYYY-MM-DD");
                    if (filterAdded) {
                        s_url += "&date=" + formattedDate;
                    } else {
                        s_url += "?date=" + formattedDate;
                        filterAdded = true;
                    }                    
                }
                if (s_cinema) {
                    if (filterAdded) {
                        s_url += "&cinema=" + s_cinema;
                    } else {
                        s_url += "?cinema=" + s_cinema;
                        filterAdded = true;
                    }                    
                }
                if (s_format) {
                    if (filterAdded) {
                        s_url += "&format=" + encodeURIComponent(s_format);
                    } else {
                        s_url += "?format=" + encodeURIComponent(s_format);
                        filterAdded = true;
                    }                    
                }

                var cinema_names=[{id:"002",name:"GR North"},{id:"003",name:"Crossroads"},{id:"004",name:"GR South"},{id:"005",name:"Rivertown"},{id:"006",name:"Lansing"},{id:"007",name:"Benton Harbor"},{id:"008",name:"Mt Pleasant"},{id:"009",name:"Cinema Carousel"},{id:"011",name:"Getty"},{id:"012",name:"Meridian Mall"},{id:"013",name:"Studio Park"}];
                cinemaNameText = ". ";
                if (s_cinema) {
                    var cinemaName = _.find(cinema_names, {"id":s_cinema}).name;
                    cinemaNameText = " at " + cinemaName + ". ";
                }

                var messageText = "";
				if (iscurrentDate) {
					messageText = "Check out showtimes for " + s_title + " playing Today" + cinemaNameText + showtimelist + "\n" + s_url;
				} else {
					messageText = "Check out showtimes for " + s_title + " on " + dayOfWeekAndMonth + cinemaNameText + showtimelist + "\n" + s_url;
				}
                
                console.log(messageText);

                //share logic
                //try to also use web api's share feature
					try {
                        navigator.clipboard.writeText(messageText);    
					    const userAgent = navigator.userAgent.toLowerCase();
						const isMobile = /android|iphone|ipod/i.test(userAgent);
						const isTablet = /ipad|tablet/i.test(userAgent) && !isMobile;

						//console.log('device info. isMobile: ' + isMobile + '. isTablet: ' + isTablet + '. UserAgent:', userAgent);
						if (isMobile || isTablet) {
							if (!navigator.canShare) {
								console.log("Your browser doesn't support the Web Share API.");
								return;
						    } else {
								console.log('can use navigator.share');
							}
							
							const shareData = {
								title: "Celebration! Cinema: " + s_title,
								text: messageText,
								//url: s_url,
							};
							console.log('share', shareData);
							try {
								navigator.share(shareData);
								console.log('sharing...');
							} catch (error) {
								console.log("can't share", error);
								//alert(error);
							}
						}
					} catch (err) {
						//do nothing, copy to clipboard is also firing
						console.log('nothing to copy to navigator clipboard',err);
					}


                if (share_button === 'film') {
                //progress bar alert
                $('.share-film-button-container').fadeOut(250);
			    setTimeout(() => {
					$('.share-film-button-text').fadeIn(250);
                    $('.share-film-button-progress').fadeIn(250);
					var totalTime = 10000 - 250;
					smoothTimer(totalTime, 100, (progress) => {
						var percent = Math.round(progress * 100);
						var remaining = 100 - percent;
						var styleWidth = remaining+'%';
                        $('.progress').css('width', styleWidth)
						//console.log(`Progress: ${percent}%`);
						});	
				}, 250);
				setTimeout(() => {
					$('.share-film-button-text').fadeOut(250); 
                    $('.share-film-button-progress').fadeOut(250); 
						setTimeout(() => {
						$('.share-film-button-container').fadeIn(250);
					}, 500);
				}, 10000);
                }

                if (share_button === 'cinema') {
                    $(self).find('.cinema-showtimes-copied').fadeIn(500);
                    setTimeout(() => {
                        $(self).find('.cinema-showtimes-copied').fadeOut(500);
				    }, 5000);
                }
         }

        //film showtime share progress bar
         function smoothTimer(duration, steps, callback) {
			const interval = duration / steps;
			for (let i = 1; i <= steps; i++) {
				setTimeout(() => {
					callback(i / steps);
				}, interval * i);
			}
		}

        //showtime confirmation modal/drawer
        var enabled = true;
        if (enabled) {
            $('#showtime-confirmation-modal').modal({ show: true, backdrop: 'static', keyboard: false });
        }
        var isShowtimeConfirmationPage = !!$('#showtime-confirmation-modal').length;
        if (enabled && isShowtimeConfirmationPage) {
            //convert time to EST via moment     
            var showtimeOG = $('#showtime-confirmation-modal .time-container').text().trim().toString();
            if (showtimeOG && window.moment) {
                //var ESTtime = moment.utc(showtimeOG, "YYYY-MM-DDTHH:mm:ssZ").tz('America/New_York').format('MMMM Do @ h:mm a');
                //var ESTtimeDayOfWeek = moment.utc(showtimeOG, "YYYY-MM-DDTHH:mm:ssZ").tz('America/New_York').format('dddd');                
                var ESTtime = moment.utc(showtimeOG, "YYYY-MM-DDTHH:mm:ssZ").format('MMMM Do @ h:mm a');
                var ESTtimeDayOfWeek = moment.utc(showtimeOG, "YYYY-MM-DDTHH:mm:ssZ").format('dddd');                
                /**
                console.log('-----testing times------');
                console.log('1',  moment(showtimeOG, "YYYY-MM-DDTHH:mm:ss").tz('America/New_York').format('MMMM Do @ h:mm a'));
                console.log('2',  moment(showtimeOG, "YYYY-MM-DDTHH:mm:ssZ").tz('America/New_York').format('MMMM Do @ h:mm a'));
                console.log('3',  moment.utc(showtimeOG, "YYYY-MM-DDTHH:mm:ssZ").tz('America/New_York').format('MMMM Do @ h:mm a'));
                console.log('4',  moment.utc(showtimeOG, "YYYY-MM-DDTHH:mm:ssZ").tz('America/New_York').format('MMMM Do @ h:mm a'));
                console.log('5',  moment(showtimeOG, "YYYY-MM-DDTHH:mm:ss").format('MMMM Do @ h:mm a'));
                console.log('6',  moment(showtimeOG, "YYYY-MM-DDTHH:mm:ssZ").format('MMMM Do @ h:mm a'));
                console.log('7',  moment.utc(showtimeOG, "YYYY-MM-DDTHH:mm:ssZ").format('MMMM Do @ h:mm a'));
                console.log('8',  moment.utc(showtimeOG, "YYYY-MM-DDTHH:mm:ssZ").format('MMMM Do @ h:mm a'));
                console.log('-----------');                
                console.log(Intl.DateTimeFormat().resolvedOptions().timeZone)
                **/
                var $div = "<span class='day-of-week'>" + ESTtimeDayOfWeek + "</span>" + "<span class='date-of-week'>" + ESTtime + "</span>";
                $('#showtime-confirmation-modal .time-container').html($div);
                $('#showtime-confirmation-modal .time-container').css('opacity', 1);

                $('#showtime-confirmation-drawer .time-container').text(ESTtime);
                $('#showtime-confirmation-drawer .time-container').css('opacity', 1);
            }
            // do something...
        };

        //Tab System bug fixes for url updating and consuming
        //Onload consuming    
        var hash = window.location.hash;

        if (hash) {
            //set a minor timeout (any time works), as handlers are attached during .ready() so we need to do this on the next event loop.
            setTimeout(function() {

                //random url bugs
                hash = hash.replace("#!#", "#");
                hash = hash.replace("#", "");

                //reroute tab active view
                if ($('.sfs-tabstrip-configurator.nav.nav-tabs a[aria-controls="' + hash + '"]')) {
                    $('.sfs-tabstrip-configurator.nav.nav-tabs a[aria-controls="' + hash + '"]').trigger('click');
                }
            }, 10);
        }

        //On click updating
        $('ul.nav-tabs li a[role="tab"]').click(function(e) {
            //$("html, body").animate({ scrollTop: 0 }, "fast");
            $('ul.nav-tabs li.active').removeClass('active')
            $(this).parent('li').addClass('active')
            var tabTop = $(this).offset().top - 150;
            window.scrollTo(0, tabTop);

            //var newValue = e.target.getAttribute("aria-controls");
            //const urlParams = new URLSearchParams(window.location.search);
            //urlParams.set('tab', newValue);
            //window.location.search = urlParams;

            var newValue = e.target.getAttribute("aria-controls");
            const url = new URL(window.location.href);
            url.searchParams.delete('tab');
            url.searchParams.delete('updatepassword');
            url.searchParams.set('tab', newValue);
            window.history.replaceState(null, null, url); // or pushState

            e.preventDefault();
        });

        const convertTabsToDD = function() {

            $(".sfs-tabstrip:not(.dd-converted)").each(function() {
                let strip = $(this);
                let menu = $(this).find(".tab-configurator");
                let tabs = $(this).find(".tab-content.tab-panels");

                let selectEl = $("<select class='form-control' />").appendTo($("<div class='sfs-tab-dropdown d-block d-md-none'><div class='form-group form-custom-select no-label'></div></div>").insertAfter(menu));
                let i = 0;
                $(menu).find(".sfs-tabstrip-configurator a").each(function() {
                    let active = false,
                        el = $(this);
                    let opt = $("<option value='" + ++i + "'>" + el.text() + "</option>").appendTo(selectEl);
                    if (el.parent().hasClass("active")) opt.attr("selected", true);
                });

                $(selectEl).change(function() {
                    tabs.find(".sfs-tabitem.tab-pane").removeClass("active");
                    var opt = $(menu).find(".sfs-tabstrip-configurator li:nth-child(" + $(this).val() + ") a");
                    tabs.find(opt.attr("href")).addClass("active");
                });

                menu.addClass("d-none d-md-flex");
                strip.addClass("dd-converted");
            });
        };

        convertTabsToDD();



        $('#sub-page-navigation-mobile').on('change', function() {
            var url = $(this).val();
            if (url) { // require a URL
                window.location = url;
            }
            return false;
        });
    });
});

function defer(method) {
    if (window.jQuery) {
        method();
    } else {
        setTimeout(function() { defer(method) }, 50);
    }
}

window.jQuery(document).ready(function() {
    AOS.init({ once: true });
});


$(document).on('click', '.tab-styled-navigation a[href^="#"]', function(event) {
    event.preventDefault();

    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top - 200
    }, 500);
});

$(".current-film").on("click", function() {
    $('.film-list').slideToggle(750);
    $('.change-film-dropdown').toggleClass("open");
    $('body').toggleClass('nav-open');
});

$(".film-list > div").on("click", function() {
    window.location.href = $(this).attr('value');
});

$('.movie-card-content-mask-text.show').on("click", function() {
    $('.movie-card-content').addClass('open');
    //$('.movie-card-content-mask').addClass('open');
    $('.movie-card-content-mask-text.show').hide();
    $('.movie-card-content-mask-text.hide').show();
});
$('.movie-card-content-mask-text.hide').on("click", function() {
    $('.movie-card-content').removeClass('open');
    //$('.movie-card-content-mask').removeClass('open');
    $('.movie-card-content-mask-text.show').show();
    $('.movie-card-content-mask-text.hide').hide();
});

window.jQuery(document).ready(function() {
    let confirmationParam = new URLSearchParams(window.location.search);
    let swapped = confirmationParam.get('confirmation');

    //if seat was swapped (i.e. confirmation param exists) then remove the param and show success message
    if (swapped === "true") {
        //clear out confirmation message in case they reload page now
        window.history.pushState({}, "", window.location.href.split("&confirmation=true")[0]);

        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });

        //show swap confirmation
        $('.seat-swap-alert.success').show();
    } else if (swapped === "false") {
        //clear out confirmation message in case they reload page now
        window.history.pushState({}, "", window.location.href.split("&confirmation=false")[0]);

        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });

        //show swap confirmation
        $('.seat-swap-alert.fail').show();
    }

    $('#no-seat-swap-allowed .new-order-number').on('keypress', function(event) {
        if (event.key === "Enter") {
            if ($(this).val() != '') {
                event.preventDefault();
                $('#loadNewBookingId i').css('display', 'inline-block');
                $('#no-seat-swap-allowed #loadNewBookingId').prop('disabled', true);
                $('#no-seat-swap-allowed #loadNewBookingId').click();
            }
        }
    });

    $('#no-seat-swap-allowed .new-order-number').on('input', function() {
        console.log('change');
        if ($(this).val() != '') {
            $('#no-seat-swap-allowed #loadNewBookingId').prop('disabled', false);
        } else {
            $('#no-seat-swap-allowed #loadNewBookingId').prop('disabled', true);
        }
    });

    $("#no-seat-swap-allowed #loadNewBookingId").on('click', function() {
        let ordernum = $('#no-seat-swap-allowed .new-order-number').val();

        let orderURL = location.protocol + '//' + location.host + location.pathname;
        orderURL += "?bookingId=" + ordernum;

        $('#loadNewBookingId i').css('display', 'inline-block');
        $('#no-seat-swap-allowed #loadNewBookingId').prop('disabled', true);

        window.location = orderURL;
    });
});

function dismissShowtimeDrawer() {
    $('#showtime-confirmation-drawer').animate({ 'left': '-205px' }, 500, function() {
        $('#showtime-confirmation-drawer').addClass('drawer-hide');
    });
}